import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Button, Card, Spinner } from "react-bootstrap";
import logoMain from "../../assets/icons/logo_main.svg";
import FormInput from "../../components/FormInput";
import { api } from "../../helpers/apiCore";
import { endpoints } from "../../helpers/Endpoints";
import { useUser } from "../../contexts/UserContext";
import errorInfoIcon from "../../assets/icons/error_info.svg";
import "../../styles/auth.css";

const Login = () => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});

	const navigate = useNavigate();
	const { setUser } = useUser();

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setIsSubmitting(true);
		setShowAlert(false);
		try {
			const response = await api.create(endpoints.loginAdmin, formData);
			const responseData = response.data;

			console.log(responseData, "response-data");
			if (responseData?.role_id) {
				setUser({
					fullName: `${responseData.first_name} ${responseData.last_name}`,
					firstName: responseData.first_name,
					lastName: responseData.last_name,
					type: responseData.user_type,
					email: responseData.email,
					role: responseData.role.name,
				});
				api.setLoggedInUser(responseData.token);
				navigate("/admin/dashboard");
			} else {
				setError(responseData.message);
				setShowAlert(true);
			}
		} catch (error: any) {
			const message =
				error?.response?.data?.message || "Unable to login, please try again";
			setError(message);
			setShowAlert(true);
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setError(null);
		const { name, value } = e.target;
		setFormData((prevFormData) => ({
			...prevFormData,
			[name]: value,
		}));
	};

	return (
		<>
			<div className="body-bg-blue">
				<div className="auth-body">
					<div className="auth-img-white mb-3">
						<img src={logoMain} alt="logo" />
						<h2>Scholarswitch</h2>
					</div>
					<Card>
						<Card.Body>
							<h3 className="mb-5">Login To Your Portal</h3>
							<form onSubmit={handleSubmit}>
								<div className="mb-4 text-left">
									<FormInput
										label="Work Email"
										name="email"
										placeholder="email"
										type="email"
										value={formData.email}
										onInput={handleChange}
									/>
								</div>
								<div className="mb-4 text-left">
									<FormInput
										label="Password"
										name="password"
										type="password"
										placeholder="*********"
										value={formData.password}
										onInput={handleChange}
									/>
								</div>

								{showAlert && (
									<>
										<Alert variant="danger" className="alert-error">
											{error && <img src={errorInfoIcon} alt="error" />}
											{error}
										</Alert>
									</>
								)}

								<Button
									type="submit"
									disabled={
										isSubmitting || !formData.email || !formData.password
									}>
									{isSubmitting ? (
										<Spinner animation="border" size="sm" />
									) : (
										"Login"
									)}
								</Button>
							</form>
							<Link to={"/auth/change-password"}>Change Password</Link>
						</Card.Body>
					</Card>
				</div>
			</div>
		</>
	);
};

export default Login;
